// https://github.com/moment/moment/issues/3650
export default function interopDefault(m) {
    return m["default"] || m;
}


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.3.3@antd/es/_util/interopDefault.js
// module id = 87
// module chunks = 0